import React from "react";
import ReactDOM from "react-dom/client";
import installStorageShim, { migrateLegacyStorage } from "./storageShim.js";
import { supabase } from "./lib/supabase.js";
import App from "./App.jsx";

// Install the window.storage shim BEFORE the prototype ever mounts, since its
// first effect reads window.storage.get(...) on load.
installStorageShim();

/* Crash beacon: report the first few unhandled errors per session to the
   admin-only client_errors table. No third-party SDK, no user identity —
   just enough to see production failures before users report them. */
(() => {
  if (!supabase) return;
  let reported = 0;
  const seen = new Set();
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const platform = /android/i.test(ua) ? "android" : /iphone|ipad|ipod/i.test(ua) ? "ios" : /win/i.test(ua) ? "windows" : /mac/i.test(ua) ? "macos" : "other";
  const report = (message, stack) => {
    const msg = String(message || "unknown").slice(0, 500);
    if (reported >= 5 || seen.has(msg)) return;
    seen.add(msg);
    reported += 1;
    supabase.from("client_errors").insert({
      message: msg,
      stack: String(stack || "").slice(0, 2000) || null,
      app_version: typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : null,
      platform,
      url: window.location.pathname.slice(0, 200),
    }).then(({ error }) => { if (error) console.warn("[Aurio] beacon failed", error.message); });
  };
  window.addEventListener("error", (e) => report(e.message, e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => report(e.reason?.message || String(e.reason), e.reason?.stack));
})();

/* Migrate legacy solvente-* storage keys to aurio-* BEFORE the app mounts,
   so its very first read already sees the carried-over data. The migration
   is idempotent and non-destructive; a failure still renders the app. */
migrateLegacyStorage().catch((err) => console.warn("[Aurio] storage migration failed", err)).finally(() => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Register the service worker for offline support + installability.
// Prod-only: keeps local `npm run dev` free of stale-cache surprises.
// Test PWA behavior with `npm run build && npm run preview`.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.error("[Aurio] service worker registration failed", err);
    });
  });
}
